import { BaseItem } from './common';

export enum Type {
  Visit = 'visit',
  Dictation = 'dictation',
}

export interface Timestamp {
  timestamp: Date;
  recordingTime: number;
  type: Type;
  isValid: boolean;
}

export type Format = 'aac' | 'flac' | 'linear16';
export const ValidFormats: {
  [key in Format]: { value: Format; extension: string };
} = {
  linear16: { value: 'linear16', extension: 'wav' },
  flac: { value: 'flac', extension: 'flac' },
  aac: { value: 'aac', extension: 'm4a' },
};

export interface BaseRecording {
  encounterId: string;
  gsPath?: string;
  timestamps: Timestamp[];
  format: Format;
  uploaded: false;
  durationMillis: number;
  isProcessingAllowed: boolean;
}

export interface Recording extends BaseRecording, BaseItem {
  uploadCompletedTime?: Date;
  deleted: boolean;
  deletedTimestamp: Date | null;
}

interface BaseSegment {
  recordingId: string;
  predictSpeechModel: string | null;
  predictLanguageModel: string | null;
  predictPunctuationModel: string | null;
  segmentApiVersion: string;
  gsPath: string;
  startMs: number;
  endMs: number;
  transcript: string | null;
  predictTranscript: string | null;
  inaudible: boolean;
  needsReview: boolean;
}

export interface Segment extends BaseSegment, BaseItem {}
